import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import app from 'flarum/forum/app';
export default class JokoakScoringCriteriaCard extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    // By default collapsed as requested
    this.isCollapsed = true;
  }
  view() {
    const game = this.attrs.game || 'bolilla';
    const teamName = this.attrs.teamName || 'Athletic Club';
    return m("div", {
      className: "JokoakScoringCriteriaCard ".concat(this.isCollapsed ? 'is-collapsed' : 'is-expanded')
    }, m("div", {
      className: "JokoakScoringCriteriaCard-header",
      onclick: () => {
        this.isCollapsed = !this.isCollapsed;
        m.redraw();
      }
    }, m("div", {
      className: "JokoakScoringCriteriaCard-headerLeft"
    }, m("span", {
      className: "JokoakScoringCriteriaCard-icon"
    }, m("i", {
      className: "fas fa-info-circle"
    })), m("h4", {
      className: "JokoakScoringCriteriaCard-title"
    }, app.translator.trans('nagusi-match-ratings.forum.scoring_criteria.title'))), m(Button, {
      className: "Button Button--link JokoakScoringCriteriaCard-toggle",
      "aria-expanded": !this.isCollapsed
    }, m("span", null, this.isCollapsed ? app.translator.trans('nagusi-match-ratings.forum.scoring_criteria.show_criteria') : app.translator.trans('nagusi-match-ratings.forum.scoring_criteria.hide_criteria')), m("i", {
      className: "fas fa-chevron-".concat(this.isCollapsed ? 'down' : 'up'),
      style: "margin-left: 6px;"
    }))), !this.isCollapsed && m("div", {
      className: "JokoakScoringCriteriaCard-body"
    }, m("div", {
      className: "JokoakScoringCriteriaCard-section"
    }, m("h5", {
      className: "JokoakScoringCriteriaCard-subtitle"
    }, m("i", {
      className: "fas fa-calculator",
      style: "margin-right: 6px; color: #ee2523;"
    }), app.translator.trans('nagusi-match-ratings.forum.scoring_criteria.scoring_title')), game === 'bolilla' && m("ul", {
      className: "JokoakScoringCriteriaCard-list"
    }, m("li", null, m("span", {
      className: "JokoakScoringCriteriaCard-bullet"
    }, "\uD83D\uDD2E"), m("span", null, app.translator.trans('nagusi-match-ratings.forum.scoring_criteria.bolilla.exact_score'))), m("li", null, m("span", {
      className: "JokoakScoringCriteriaCard-bullet"
    }, "\uD83C\uDFC6"), m("span", null, app.translator.trans('nagusi-match-ratings.forum.scoring_criteria.bolilla.knockout_winner')))), game === 'lineup' && m("ul", {
      className: "JokoakScoringCriteriaCard-list"
    }, m("li", null, m("span", {
      className: "JokoakScoringCriteriaCard-bullet"
    }, "\uD83D\uDEE1\uFE0F"), m("span", null, app.translator.trans('nagusi-match-ratings.forum.scoring_criteria.lineup.starter'))), m("li", null, m("span", {
      className: "JokoakScoringCriteriaCard-bullet"
    }, "\uD83C\uDF1F"), m("span", null, app.translator.trans('nagusi-match-ratings.forum.scoring_criteria.lineup.perfect_bonus'))), m("li", null, m("span", {
      className: "JokoakScoringCriteriaCard-bullet"
    }, "\u23F0"), m("span", null, app.translator.trans('nagusi-match-ratings.forum.scoring_criteria.lineup.deadline')))), game === 'gorbea' && m("ul", {
      className: "JokoakScoringCriteriaCard-list"
    }, m("li", null, m("div", null, m("span", {
      className: "JokoakScoringCriteriaCard-bullet"
    }, "\u26F0\uFE0F"), m("strong", null, app.translator.trans('nagusi-match-ratings.forum.scoring_criteria.gorbea.league_title')), " ", app.translator.trans('nagusi-match-ratings.forum.scoring_criteria.gorbea.league_base')), m("ul", {
      className: "JokoakScoringCriteriaCard-sublist"
    }, m("li", null, app.translator.trans('nagusi-match-ratings.forum.scoring_criteria.gorbea.league_bonus_team', {
      team: teamName
    })), m("li", null, app.translator.trans('nagusi-match-ratings.forum.scoring_criteria.gorbea.league_bonus_champion')), m("li", null, app.translator.trans('nagusi-match-ratings.forum.scoring_criteria.gorbea.league_bonus_relegation')))), m("li", null, m("span", {
      className: "JokoakScoringCriteriaCard-bullet"
    }, "\u26BD"), m("span", null, app.translator.trans('nagusi-match-ratings.forum.scoring_criteria.gorbea.scorers_assists'))), m("li", null, m("span", {
      className: "JokoakScoringCriteriaCard-bullet"
    }, "\uD83C\uDFC6"), m("span", null, app.translator.trans('nagusi-match-ratings.forum.scoring_criteria.gorbea.copa'))), m("li", null, m("span", {
      className: "JokoakScoringCriteriaCard-bullet"
    }, "\uD83E\uDDE4"), m("span", null, app.translator.trans('nagusi-match-ratings.forum.scoring_criteria.gorbea.stats'))))), m("div", {
      className: "JokoakScoringCriteriaCard-section JokoakScoringCriteriaCard-tiebreakerSection"
    }, m("h5", {
      className: "JokoakScoringCriteriaCard-subtitle"
    }, m("i", {
      className: "fas fa-handshake",
      style: "margin-right: 6px; color: #f59e0b;"
    }), app.translator.trans('nagusi-match-ratings.forum.scoring_criteria.tiebreaker_title')), m("p", {
      className: "JokoakScoringCriteriaCard-tiebreakerText"
    }, game === 'bolilla' && app.translator.trans('nagusi-match-ratings.forum.scoring_criteria.bolilla.tiebreaker'), game === 'lineup' && app.translator.trans('nagusi-match-ratings.forum.scoring_criteria.lineup.tiebreaker'), game === 'gorbea' && app.translator.trans('nagusi-match-ratings.forum.scoring_criteria.gorbea.tiebreaker')))));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/aurrera-jokoak/JokoakScoringCriteriaCard', JokoakScoringCriteriaCard);